/**
 * @generated SignedSource<<2852c8de846d45c6c526fc8e32504738>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ConfigScreen = "basic" | "l_layout" | "media_only" | "multi_column_schedule" | "multi_day_schedule" | "mvp" | "nutrition" | "schedule_only" | "strength" | "vertical_multi_day_schedule" | "vertical_multi_row_schedule" | "vertical_stacked" | "vertical_strength" | "weather" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ConfigurationPicker_ScreenConfigs_Organisation$data = {
  readonly id: string;
  readonly screenConfigs: {
    readonly edges: ReadonlyArray<{
      readonly cursor: string;
      readonly node: {
        readonly configType: ConfigScreen;
        readonly id: string;
        readonly name: string;
      };
    }>;
  };
  readonly " $fragmentType": "ConfigurationPicker_ScreenConfigs_Organisation";
};
export type ConfigurationPicker_ScreenConfigs_Organisation$key = {
  readonly " $data"?: ConfigurationPicker_ScreenConfigs_Organisation$data;
  readonly " $fragmentSpreads": FragmentRefs<"ConfigurationPicker_ScreenConfigs_Organisation">;
};

import ConfigurationPicker_ScreenConfigs_graphql from './ConfigurationPicker_ScreenConfigs.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "screenConfigs"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "after"
    },
    {
      "kind": "RootArgument",
      "name": "first"
    },
    {
      "kind": "RootArgument",
      "name": "searchText"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": ConfigurationPicker_ScreenConfigs_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "ConfigurationPicker_ScreenConfigs_Organisation",
  "selections": [
    {
      "alias": "screenConfigs",
      "args": [
        {
          "kind": "Variable",
          "name": "searchText",
          "variableName": "searchText"
        }
      ],
      "concreteType": "ScreenConfigConnection",
      "kind": "LinkedField",
      "name": "__ConfigurationPicker_screenConfigs_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ScreenConfigEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ScreenConfig",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "configType",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v1/*: any*/)
  ],
  "type": "Organisation",
  "abstractKey": null
};
})();

(node as any).hash = "245bef588d5028e26dd0c1c0a5dc56fd";

export default node;
